/**
 * PRESCRIPTION SYSTEM v2 — Savor port
 * Vanilla JS. No jQuery, no BCPO, no external drawer helpers.
 * Reads window.PRESC_DATA injected by snippets/prescription-drawer.liquid.
 * Dispatches Savor's `cart:update` event after adds so the native cart
 * drawer re-renders and (with auto-open) opens.
 */

(function () {
  'use strict';

  var SWATCH_GRADIENTS = {
    brown:  'radial-gradient(circle at 40% 35%, #C4904A, #5C3010)',
    gold:   'radial-gradient(circle at 40% 35%, #C4904A, #5C3010)',
    silver: 'radial-gradient(circle at 40% 35%, #D0D0D0, #606060)',
    grey:   'radial-gradient(circle at 40% 35%, #D0D0D0, #606060)',
    gray:   'radial-gradient(circle at 40% 35%, #D0D0D0, #606060)',
    blue:   'radial-gradient(circle at 40% 35%, #7AAEE8, #1A3B6B)',
    green:  'radial-gradient(circle at 40% 35%, #6BAF6B, #1A4A1A)',
    teal:   'radial-gradient(circle at 40% 35%, #4BAFAF, #0A3A3A)',
    pink:   'radial-gradient(circle at 40% 35%, #E88BB8, #6B1A3A)',
    rose:   'radial-gradient(circle at 40% 35%, #E88BB8, #6B1A3A)',
    purple: 'radial-gradient(circle at 40% 35%, #B88BE8, #3A1A6B)',
    violet: 'radial-gradient(circle at 40% 35%, #B88BE8, #3A1A6B)',
  };

  var state = {
    selectedTierIndex: 0,
    selectedTransitionVariantId: null,
    uploadedFileName: null,
    processing: false,
  };

  var els = {}; /* cached on init */

  /* ────────────────────────── helpers ────────────────────────── */

  function qs(sel, root)  { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function parseValues(raw) {
    if (!raw) return [];
    if (Array.isArray(raw)) return raw.map(String);
    raw = String(raw).trim();
    if (raw.charAt(0) === '[') {
      try { return JSON.parse(raw).map(String); } catch (e) { /* fall through */ }
    }
    return raw.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
  }

  /** Store-currency money formatting via shop.money_format */
  function formatMoney(cents, moneyFormat) {
    var value = (cents / 100).toFixed(2);
    var format = moneyFormat || '{{ amount }}';
    return format
      .replace(/\{\{\s*amount\s*\}\}/, value)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100).toString())
      .replace(/<[^>]+>/g, ''); /* strip any HTML wrappers in the format */
  }

  function swatchGradient(variant) {
    if (variant.hex) {
      return 'radial-gradient(circle at 40% 35%, ' + variant.hex + 'CC, ' + variant.hex + '55)';
    }
    var title = (variant.title || '').toLowerCase();
    for (var key in SWATCH_GRADIENTS) {
      if (title.indexOf(key) !== -1) return SWATCH_GRADIENTS[key];
    }
    return 'radial-gradient(circle at 40% 35%, #999, #333)';
  }

  /** Current frame variant from any product form on the page */
  function getFrameVariantId() {
    var input = qs('product-form-component form[action*="/cart/add"] input[name="id"]') ||
                qs('form[action*="/cart/add"] input[name="id"]');
    return input ? input.value : null;
  }

  /** Section IDs of any cart-items components so Shopify returns re-render HTML */
  function cartSectionIds() {
    return qsa('cart-items-component')
      .map(function (el) { return el.dataset.sectionId; })
      .filter(Boolean);
  }

  /* ────────────────────────── drawer open/close ────────────────────────── */

  function openDrawer() {
    els.overlay.hidden = false;
    els.drawer.hidden = false;
    /* next frame so the transition runs */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        els.overlay.classList.add('is-open');
        els.drawer.classList.add('is-open');
      });
    });
    document.body.style.overflow = 'hidden';
    els.drawer.focus && els.drawer.focus();
  }

  function closeDrawer() {
    els.overlay.classList.remove('is-open');
    els.drawer.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () {
      els.overlay.hidden = true;
      els.drawer.hidden = true;
    }, 350);
  }

  function openFormScreen() {
    els.formScreen.classList.add('is-active');
    if (els.progressFill) els.progressFill.style.width = '100%';
  }

  function closeFormScreen() {
    els.formScreen.classList.remove('is-active');
    if (els.progressFill) els.progressFill.style.width = '50%';
  }

  /* ────────────────────────── price display ────────────────────────── */

  function updateTotalPrice(data) {
    var tier = data.tiers[state.selectedTierIndex];
    if (!tier) return;

    var total = data.productPrice + tier.price;
    if (state.selectedTransitionVariantId) {
      var t = (data.transition.variants || []).find(function (v) {
        return String(v.id) === String(state.selectedTransitionVariantId);
      });
      if (t) total += t.price;
    }

    var el = qs('#presc-total-price');
    if (el) el.textContent = formatMoney(total, data.moneyFormat);
  }

  /* ────────────────────────── form builder ────────────────────────── */

  function buildSelect(name, values, placeholder) {
    var opts = '<option value="">' + (placeholder || '—') + '</option>';
    values.forEach(function (v) {
      opts += '<option value="' + v + '">' + v + '</option>';
    });
    return '<select class="presc-select" name="' + name + '">' + opts + '</select>';
  }

  function buildGrid(tier) {
    var sph  = parseValues(tier.sphValues);
    var cyl  = parseValues(tier.cylValues);
    var axis = parseValues(tier.axisValues);
    var add  = tier.addValues ? parseValues(tier.addValues) : null;

    var rows = [
      { label: 'Sphere (SPH)',   leftName: 'sph_left',  rightName: 'sph_right',  values: sph  },
      { label: 'Cylinder (CYL)', leftName: 'cyl_left',  rightName: 'cyl_right',  values: cyl  },
      { label: 'AXIS',           leftName: 'axis_left', rightName: 'axis_right', values: axis },
    ];
    if (add && add.length) {
      rows.push({ label: 'ADD', leftName: 'add_left', rightName: 'add_right', values: add });
    }

    var html = '<div class="presc-grid">';
    html += '<div class="presc-grid-header">' +
              '<div></div>' +
              '<div>LEFT (OS)</div>' +
              '<div>RIGHT (OD)</div>' +
            '</div>';
    rows.forEach(function (row) {
      html += '<div class="presc-grid-row">' +
                '<div class="presc-grid-label">' + row.label + '</div>' +
                '<div>' + buildSelect(row.leftName, row.values) + '</div>' +
                '<div>' + buildSelect(row.rightName, row.values) + '</div>' +
              '</div>';
    });
    html += '</div>';
    return html;
  }

  function buildPDRow(tier) {
    var opts = '<option value="">—</option>';
    for (var i = tier.pdMin; i <= tier.pdMax; i++) {
      opts += '<option value="' + i + '">' + i + ' mm</option>';
    }
    return '<div class="presc-pd-row">' +
      '<div class="presc-pd-label">Pupillary Distance (PD)</div>' +
      '<div class="presc-pd-field">' +
        '<select class="presc-select" name="pd">' + opts + '</select>' +
        '<button type="button" class="presc-link" data-presc-modal-open="pd">WHAT IS PD?</button>' +
      '</div>' +
    '</div>';
  }

  function renderForm(data, tierIndex) {
    var tier = data.tiers[tierIndex];
    if (!tier) return;

    var fieldsEl = qs('#presc-fields-container');
    var pdEl = qs('#presc-pd-container');
    if (fieldsEl) fieldsEl.innerHTML = buildGrid(tier);
    if (pdEl) pdEl.innerHTML = buildPDRow(tier);

    var heading = qs('#presc-form-heading');
    if (heading) heading.textContent = (tier.label || 'PRESCRIPTION').toUpperCase();

    updateTotalPrice(data);
  }

  /* ────────────────────────── transition swatches ────────────────────────── */

  function buildTransitionSwatches(data) {
    var el = qs('#presc-transition-swatches');
    if (!el) return;

    var variants = data.transition.variants || [];
    if (!variants.length) return;

    var priceLabel = qs('#presc-transition-price-label');
    if (priceLabel && variants[0]) priceLabel.textContent = '+' + variants[0].priceFmt;

    var html = '';
    variants.forEach(function (v) {
      var imgHtml = v.image
        ? '<img src="' + v.image + '&width=120" alt="' + v.title + '" loading="lazy">'
        : '<div style="width:100%;height:100%;background:' + swatchGradient(v) + ';"></div>';
      html += '<div class="presc-swatch-tile" data-variant-id="' + v.id + '">' +
                '<div class="presc-swatch-img">' + imgHtml + '</div>' +
                '<div class="presc-swatch-name">' + v.title + '</div>' +
              '</div>';
    });
    html += '<div class="presc-swatch-tile presc-swatch-tile--none is-selected" data-variant-id="">' +
              '<div class="presc-swatch-img presc-swatch-img--none">' +
                '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><line x1="4" y1="4" x2="20" y2="20"/><line x1="20" y1="4" x2="4" y2="20"/></svg>' +
              '</div>' +
              '<div class="presc-swatch-name">None</div>' +
            '</div>';
    el.innerHTML = html;

    el.addEventListener('click', function (e) {
      var tile = e.target.closest('.presc-swatch-tile');
      if (!tile) return;
      qsa('.presc-swatch-tile', el).forEach(function (t) { t.classList.remove('is-selected'); });
      tile.classList.add('is-selected');

      var variantId = tile.getAttribute('data-variant-id');
      state.selectedTransitionVariantId = variantId || null;

      var label = qs('#presc-transition-label');
      if (label) {
        if (!variantId) {
          label.textContent = 'None';
        } else {
          var match = variants.find(function (v) { return String(v.id) === String(variantId); });
          label.textContent = match ? match.title : '';
        }
      }
      updateTotalPrice(data);
    });
  }

  /* ────────────────────────── cart adds ────────────────────────── */

  function cartAdd(payload) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload),
    }).then(function (res) {
      if (!res.ok) return res.json().then(function (j) { throw j; });
      return res.json();
    });
  }

  function addFrameToCart(variantId, groupId) {
    var payload = { id: Number(variantId), quantity: 1 };
    if (groupId) payload.properties = { _group_id: groupId };
    return cartAdd(payload);
  }

  function addPrescriptionFeeToCart(tier, properties) {
    return cartAdd({ id: tier.variantId, quantity: 1, properties: properties });
  }

  /** Last add carries `sections` so the response includes re-render HTML */
  function addTransitionOrFinalize(data, groupId, isTransition) {
    var sections = cartSectionIds();
    var payload;
    if (isTransition) {
      payload = {
        id: Number(state.selectedTransitionVariantId),
        quantity: 1,
        properties: { Frame: data.productTitle, _group_id: groupId },
      };
    }
    if (payload && sections.length) payload.sections = sections.join(',');
    return payload ? cartAdd(payload) : Promise.resolve(null);
  }

  /** Fetch fresh cart + section HTML, then fire Savor's cart:update event */
  function notifyThemeCartUpdated() {
    var sections = cartSectionIds();
    var url = '/cart.js';
    return fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var sectionsFetch = sections.length
          ? fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + '?sections=' + sections.join(',') : '/?sections=' + sections.join(','))
              .then(function (r) { return r.json(); })
              .catch(function () { return null; })
          : Promise.resolve(null);

        return sectionsFetch.then(function (sectionHtml) {
          var evt = new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              sourceId: 'prescription-system',
              data: {
                source: 'product-form-component',
                itemCount: cart.item_count,
                sections: sectionHtml || undefined,
              },
            },
          });
          document.dispatchEvent(evt);
          return cart;
        });
      });
  }

  /* ────────────────────────── validation + properties ────────────────────────── */

  function collectFormValues() {
    var values = {};
    var valid = true;

    ['sph_left', 'sph_right', 'cyl_left', 'cyl_right', 'axis_left', 'axis_right', 'pd'].forEach(function (name) {
      var el = qs('#presc-form-screen select[name="' + name + '"]');
      if (!el) return;
      if (!el.value) valid = false;
      values[name] = el.value;
    });

    ['add_left', 'add_right'].forEach(function (name) {
      var el = qs('#presc-form-screen select[name="' + name + '"]');
      if (!el) return; /* not shown for this tier */
      if (!el.value) valid = false;
      values[name] = el.value;
    });

    return valid ? values : null;
  }

  function buildLineItemProperties(data, tier, formValues, groupId) {
    var props = {};
    if (groupId) props['_group_id'] = groupId;
    props['Frame'] = data.productTitle;
    props['Sphere (SPH)']   = '(Left (OS): ' + formValues.sph_left  + ', Right (OD): ' + formValues.sph_right  + ')';
    props['Cylinder (CYL)'] = '(Left (OS): ' + formValues.cyl_left  + ', Right (OD): ' + formValues.cyl_right  + ')';
    props['AXIS']           = '(Left (OS): ' + formValues.axis_left + ', Right (OD): ' + formValues.axis_right + ')';
    props['PD']             = formValues.pd;
    if (formValues.add_left && formValues.add_right) {
      props['ADD'] = '(Left (OS): ' + formValues.add_left + ', Right (OD): ' + formValues.add_right + ')';
    }
    if (state.uploadedFileName) {
      props['_Prescription File'] = state.uploadedFileName +
        (data.contactEmail ? ' (please also email to ' + data.contactEmail + ')' : '');
    }
    return props;
  }

  /* ────────────────────────── add-to-bag flow ────────────────────────── */

  function handleAddToBag(data) {
    if (state.processing) return;

    var btn = els.addBtn;
    var checkbox = qs('#presc-confirm-checkbox');

    /* 1. confirm checkbox */
    if (!checkbox.classList.contains('is-checked')) {
      checkbox.classList.add('is-error');
      checkbox.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    /* 2. all fields */
    var formValues = collectFormValues();
    if (!formValues) {
      qsa('#presc-form-screen select').forEach(function (s) {
        if (!s.value) s.classList.add('presc-select--error');
      });
      return;
    }
    qsa('#presc-form-screen select').forEach(function (s) { s.classList.remove('presc-select--error'); });

    /* 3. frame variant */
    var frameVariantId = getFrameVariantId();
    if (!frameVariantId) {
      console.error('Prescription: could not find frame variant ID');
      return;
    }

    var tier = data.tiers[state.selectedTierIndex];
    if (!tier) return;

    /* 4. lock */
    var originalText = btn.getAttribute('data-original-text') || 'ADD TO BAG';
    state.processing = true;
    btn.classList.add('is-loading');
    btn.textContent = 'Adding...';

    /* 5. one group id links frame + fee + transition */
    var groupId = 'rx-' + Date.now() + '-' + Math.random().toString(36).slice(2, 7);
    var prescProps = buildLineItemProperties(data, tier, formValues, groupId);

    /* 6. sequential adds — frame LAST so it renders on top in the cart
       (Shopify lists most-recently-added first; members nest beneath). */
    addPrescriptionFeeToCart(tier, prescProps)
      .then(function () {
        if (state.selectedTransitionVariantId) {
          return addTransitionOrFinalize(data, groupId, true);
        }
        return null;
      })
      .then(function () { return addFrameToCart(frameVariantId, groupId); })
      .then(function () { return notifyThemeCartUpdated(); })
      .then(function () {
        closeDrawer();
        resetForm(data);
        state.processing = false;
        btn.classList.remove('is-loading');
        btn.textContent = originalText;
      })
      .catch(function (err) {
        console.error('Prescription cart add error:', err);
        state.processing = false;
        btn.classList.remove('is-loading');
        btn.classList.add('is-error');
        btn.textContent = 'SOMETHING WENT WRONG — TRY AGAIN';
        setTimeout(function () {
          btn.classList.remove('is-error');
          btn.textContent = originalText;
        }, 4000);
      });
  }

  /* ────────────────────────── reset ────────────────────────── */

  function resetForm(data) {
    state.selectedTierIndex = 0;
    state.selectedTransitionVariantId = null;
    state.uploadedFileName = null;

    qsa('#presc-form-screen select').forEach(function (s) { s.value = ''; });

    var checkbox = qs('#presc-confirm-checkbox');
    if (checkbox) {
      checkbox.classList.remove('is-checked', 'is-error');
      checkbox.setAttribute('aria-checked', 'false');
    }

    var nameEl = qs('#presc-upload-name');
    if (nameEl) nameEl.textContent = 'No file chosen';
    var fileInput = qs('#presc-file-input');
    if (fileInput) fileInput.value = '';

    qsa('.presc-swatch-tile').forEach(function (t) { t.classList.remove('is-selected'); });
    var noneTile = qs('.presc-swatch-tile--none');
    if (noneTile) noneTile.classList.add('is-selected');
    var label = qs('#presc-transition-label');
    if (label) label.textContent = 'None';

    qsa('#presc-tier-list .presc-tier').forEach(function (t, i) {
      t.classList.toggle('is-selected', i === 0);
    });

    closeFormScreen();
    renderForm(data, 0);
    updateTotalPrice(data);
  }

  /* ────────────────────────── event wiring ────────────────────────── */

  function wireEvents(data) {
    /* Trigger button(s) rendered by buy-buttons block */
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-presc-open]')) {
        e.preventDefault();
        openDrawer();
      }
    });

    /* Overlay + close buttons */
    els.overlay.addEventListener('click', closeDrawer);
    qsa('[data-presc-close]', els.drawer).forEach(function (b) {
      b.addEventListener('click', closeDrawer);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !els.drawer.hidden) closeDrawer();
    });

    /* Back button on form screen */
    qsa('[data-presc-back]', els.drawer).forEach(function (b) {
      b.addEventListener('click', closeFormScreen);
    });

    /* Tier selection */
    els.drawer.addEventListener('click', function (e) {
      var tierBtn = e.target.closest('.presc-tier[data-tier-index]');
      if (tierBtn) {
        var index = parseInt(tierBtn.getAttribute('data-tier-index'), 10);
        state.selectedTierIndex = index;
        qsa('#presc-tier-list .presc-tier').forEach(function (t) { t.classList.remove('is-selected'); });
        tierBtn.classList.add('is-selected');
        renderForm(data, index);
        openFormScreen();
        return;
      }

      /* Info modal open/close */
      var modalOpen = e.target.closest('[data-presc-modal-open]');
      if (modalOpen) {
        var pane = modalOpen.getAttribute('data-presc-modal-open');
        qsa('[data-presc-modal-pane]', els.modal).forEach(function (p) {
          p.hidden = p.getAttribute('data-presc-modal-pane') !== pane;
        });
        els.modal.hidden = false;
        return;
      }
      if (e.target.closest('[data-presc-modal-close]')) {
        els.modal.hidden = true;
        return;
      }

      /* Confirm checkbox */
      var confirmBox = e.target.closest('.presc-confirm');
      if (confirmBox) {
        var box = qs('#presc-confirm-checkbox');
        var checked = box.classList.toggle('is-checked');
        box.classList.remove('is-error');
        box.setAttribute('aria-checked', checked ? 'true' : 'false');
        return;
      }
    });

    /* Checkbox keyboard support */
    var box = qs('#presc-confirm-checkbox');
    if (box) {
      box.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Enter') {
          e.preventDefault();
          var checked = box.classList.toggle('is-checked');
          box.classList.remove('is-error');
          box.setAttribute('aria-checked', checked ? 'true' : 'false');
        }
      });
    }

    /* Field error clearing */
    els.drawer.addEventListener('change', function (e) {
      if (e.target.matches('.presc-select')) {
        e.target.classList.remove('presc-select--error');
      }
      if (e.target.matches('#presc-file-input')) {
        var file = e.target.files[0];
        state.uploadedFileName = file ? file.name : null;
        var el = qs('#presc-upload-name');
        if (el) el.textContent = file ? file.name : 'No file chosen';
      }
    });

    /* Add to bag */
    els.addBtn.addEventListener('click', function () { handleAddToBag(data); });
  }

  /* ────────────────────────── init ────────────────────────── */

  function init() {
    var drawerEl = qs('.presc-drawer[data-product-id]');
    if (!drawerEl) return;

    var productId = parseInt(drawerEl.getAttribute('data-product-id'), 10);
    var data = window.PRESC_DATA && window.PRESC_DATA[productId];
    if (!data || !data.tiers || !data.tiers.length) return;

    els.drawer = drawerEl;
    els.overlay = qs('#presc-overlay');
    els.formScreen = qs('#presc-form-screen');
    els.progressFill = qs('#presc-progress-fill');
    els.modal = qs('#presc-modal');
    els.addBtn = qs('#presc-add-btn');

    if (els.progressFill) els.progressFill.style.width = '50%';

    renderForm(data, 0);
    if (data.hasTransition && data.transition && data.transition.variants.length) {
      buildTransitionSwatches(data);
    }
    wireEvents(data);

    console.log('✅ Prescription system v2 (Savor) initialised for product', productId);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
